import { DEFAULT_BRAND_LOGO } from '@fontbold/ui';
import type { Space } from '#/lib/queries/space';

export const DEFAULT_LOGO = DEFAULT_BRAND_LOGO;

export function spaceLogo(space: Space): string {
  return space.curator?.logo.url ?? space.logo.url;
}
